import { Provider, WorkflowCodeType, WorkflowComponentOutputType, WorkflowComponentParamType } from '../types';
import { WorkflowComponent } from './common/workflowcomponent';
class ReadTable extends WorkflowComponent {
    constructor() {
        super({
            name: 'ReadTable',
            group: '__internal',
            title: 'Read Table',
            description: ''
        }, [
            {
                name: 'source',
                type: WorkflowComponentParamType.String,
                title: 'Source table fqn'
            }
        ], [
            {
                name: 'out',
                title: 'Table',
                description: 'The output table',
                type: WorkflowComponentOutputType.Table
            }
        ]);
        this.hidden = true;
        this.supportedProviders = [
            Provider.BigQuery,
            Provider.Postgres,
            Provider.Redshift,
            Provider.Snowflake,
            Provider.DatabricksRest
        ];
    }
    async getFullCodeSnippet(params) {
        if (params.codeType === WorkflowCodeType.DryRun) {
            return await super.getFullCodeSnippet(params);
        }
        else {
            return {
                query: '',
                outputs: {
                    out: params.params.source
                }
            };
        }
    }
    async getCode({ params, codeType, connection, workflow }) {
        if (codeType === WorkflowCodeType.DryRun) {
            const tablename = connection.getOutputTableName(workflow.id, this.metadata.name, params, 'out', codeType);
            const query = connection.getCreateTempTableQuery(tablename, `SELECT * FROM ${connection.quoteName(params.source)}`, codeType, null);
            return {
                query,
                outputs: { out: tablename }
            };
        }
        else {
            return {
                query: '',
                outputs: { out: params.source }
            };
        }
    }
    getOutputTables({ workflow, params, codeType, connection }) {
        if (codeType === WorkflowCodeType.DryRun) {
            const tablename = connection.getOutputTableName(workflow.id, this.metadata.name, params, 'out', codeType);
            return { out: tablename };
        }
        else {
            return { out: params.source };
        }
    }
}
export { ReadTable };
